import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MapComponent } from '../map.component';
import VectorSource from 'ol/source/Vector';
import { Vector as VectorLayer } from 'ol/layer';
import { StyleFunction, Feature } from 'ol';

@Component({
    selector: 'app-address-layer',
    template: ''
})
export class AddressLayerComponent implements OnInit, OnChanges, OnDestroy {
    @Input() id: string;
    @Input() visible: boolean;
    @Input() features: Feature[];
    @Input() styleFunction: StyleFunction;
    private lastZoom: number;
    vectorLayer: VectorLayer;

    constructor(
        private _map: MapComponent
    ) { }

    ngOnInit(): void {
        this.vectorLayer = this.initializeVectorLayer();
        this._map.instance.addLayer(this.vectorLayer);
        this._map.instance.on('moveend', () => {
            const currentZoom: number = this._map.instance.getView().getZoom();
            if (this.lastZoom === currentZoom) {
                return;
            }
            if (this.features !== undefined) {
                this.features.forEach((f: Feature) => {
                    f.setProperties({ visible: currentZoom >= 15 });
                });
                this.vectorLayer.getSource().clear();
                this.vectorLayer.getSource().addFeatures(this.features);
                this.lastZoom = currentZoom;
            }
        });
        if (this.id) {
            this.vectorLayer.set('id', this.id);
        } else {
            this.vectorLayer.set('id', 'address');
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.vectorLayer) {
            return;
        }
        if ('features' in changes) {
            this.features.forEach((f: Feature) => {
                f.setProperties({ visible: this.lastZoom >= 15 });
            });
            this.vectorLayer.getSource().clear();
            this.vectorLayer.getSource().addFeatures(this.features);
        }
        if ('visible' in changes) {
            this.vectorLayer.setVisible(this.visible);
        }
    }

    ngOnDestroy(): void {
        this.vectorLayer.getSource().clear();
        this._map.instance.removeLayer(this.vectorLayer);
    }

    initializeVectorLayer(): VectorLayer {
        return new VectorLayer({
            visible: this.visible,
            source: new VectorSource({
                features: this.features ? this.features : [],
            }),
            style: this.styleFunction ? this.styleFunction : undefined
        });
    }
}



// WEBPACK FOOTER //
// ./libs/map/components/layers/address-layer.component.ts